var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecording(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54807 7.25348C6.54807 6.5748 5.99789 6.02462 5.31921 6.02462C4.64053 6.02462 4.09036 6.5748 4.09036 7.25348V17.7475C4.09036 18.4261 4.64053 18.9763 5.31921 18.9763C5.99789 18.9763 6.54807 18.4261 6.54807 17.7475V7.25348Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7289 7.25348C13.7289 6.5748 13.1787 6.02462 12.5 6.02462C11.8213 6.02462 11.2712 6.5748 11.2712 7.25348V17.7475C11.2712 18.4261 11.8213 18.9763 12.5 18.9763C13.1787 18.9763 13.7289 18.4261 13.7289 17.7475V7.25348Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9096 7.25348C20.9096 6.5748 20.3595 6.02462 19.6808 6.02462C19.0021 6.02462 18.4519 6.5748 18.4519 7.25348V17.7475C18.4519 18.4261 19.0021 18.9763 19.6808 18.9763C20.3595 18.9763 20.9096 18.4261 20.9096 17.7475V7.25348Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95771 9.81765C2.95771 9.13897 2.40753 8.5888 1.72885 8.5888C1.05018 8.5888 0.5 9.13898 0.5 9.81765V15.1833C0.5 15.862 1.05018 16.4121 1.72885 16.4121C2.40753 16.4121 2.95771 15.862 2.95771 15.1833V9.81765Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3192 9.81765C17.3192 9.13897 16.7691 8.5888 16.0904 8.5888C15.4117 8.5888 14.8615 9.13897 14.8615 9.81765V15.1833C14.8615 15.862 15.4117 16.4121 16.0904 16.4121C16.7691 16.4121 17.3192 15.862 17.3192 15.1833V9.81765Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9.81765C24.5 9.13897 23.9498 8.5888 23.2711 8.5888C22.5925 8.5888 22.0423 9.13897 22.0423 9.81765V15.1833C22.0423 15.862 22.5925 16.4121 23.2711 16.4121C23.9498 16.4121 24.5 15.862 24.5 15.1833V9.81765Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1385 4.6893C10.1385 4.01063 9.5883 3.46045 8.90962 3.46045C8.23094 3.46045 7.68076 4.01063 7.68076 4.68931V20.3116C7.68076 20.9903 8.23094 21.5405 8.90962 21.5405C9.5883 21.5405 10.1385 20.9903 10.1385 20.3116V4.6893Z",
    fill: "rgba(0, 0, 0, 0.6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.500488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording);
export default __webpack_public_path__ + "static/media/recording.1806875ccc2069e8dc1904d89a69bcd1.svg";
export { ForwardRef as ReactComponent };